export default class FilterUtil {

    static statusList = [
        'активный', 'неактивный'
    ]

    static checkStatus(value, filterStatus) {
        const status = Array.isArray(filterStatus) ? filterStatus[0] : filterStatus;
        if (status === FilterUtil.statusList[0]) {
            return !!value;
        }
        if (status === FilterUtil.statusList[1]) {
            return !value;
        }
        return false;
    }
}